'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _contacts = require('redux/modules/contacts');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _AddContactSuggestForm = require('components/AddContact/AddContactSuggestForm/AddContactSuggestForm');

var _AddContactSuggestForm2 = _interopRequireDefault(_AddContactSuggestForm);

var _contacts2 = require('selectors/contacts');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var fieldName = 'statsViewerEmail';

var AddStatsViewerField = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    addStatsViewerLoading: state.statistics.addStatsViewerLoading,
    projectData: state.project.projectData,
    suggestionList: (0, _contacts2.getSuggestionList)(state)
  };
}, (0, _extends3.default)({}, statisticsActions, { loadSuggestionUsersList: _contacts.loadSuggestionUsersList })), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(AddStatsViewerField, _Component);

  function AddStatsViewerField() {
    (0, _classCallCheck3.default)(this, AddStatsViewerField);
    return (0, _possibleConstructorReturn3.default)(this, (AddStatsViewerField.__proto__ || (0, _getPrototypeOf2.default)(AddStatsViewerField)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddStatsViewerField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadSuggestionUsersList();
    }
  }, {
    key: 'onSuggestionSelected',
    value: function onSuggestionSelected(_ref) {
      var suggestion = _ref.suggestion;

      return this.addStatsViewer(suggestion);
    }
  }, {
    key: 'getAutosuggestItems',
    value: function getAutosuggestItems() {
      var suggestionList = this.props.suggestionList;

      var items = [];
      suggestionList.map(function (user) {
        return items.push((0, _extends3.default)({}, user, { _name: user.email, _type: 'user' }));
      });
      return items;
    }
  }, {
    key: 'addStatsViewer',
    value: function addStatsViewer(formData) {
      var _props = this.props,
          projectId = _props.projectId,
          onAdd = _props.onAdd;

      var data = (0, _extends3.default)({ projectId: projectId }, formData);
      if (data[fieldName]) {
        data.email = data[fieldName];
      }

      var promise = this.props.addStatsViewer(data).promise;
      promise.then(function () {
        return onAdd(data);
      }).catch(function (err) {
        return err;
      });
      return promise;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          addStatsViewerLoading = _props2.addStatsViewerLoading,
          withZIndex = _props2.withZIndex;

      var items = this.getAutosuggestItems();

      return _react2.default.createElement(_AddContactSuggestForm2.default, {
        fieldName: fieldName,
        onSuggestionSelected: this.onSuggestionSelected,
        onSubmit: this.onSubmit,
        items: items,
        onAddNewContact: this.addStatsViewer,
        onAddNewContactLoading: addStatsViewerLoading,
        loading: addStatsViewerLoading,
        withZIndex: withZIndex
      });
    }
  }]);
  return AddStatsViewerField;
}(_ClientSideComponent2.default), _class3.propTypes = {
  addStatsViewer: _propTypes2.default.func,
  addStatsViewerLoading: _propTypes2.default.bool,
  loadSuggestionUsersList: _propTypes2.default.func,
  onAdd: _propTypes2.default.func,
  projectId: _propTypes2.default.number.isRequired,
  suggestionList: _propTypes2.default.array,
  withZIndex: _propTypes2.default.bool
}, _class3.defaultProps = {
  addStatsViewerLoading: false,
  onAdd: _noop3.default,
  projectData: {},
  suggestionList: []
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSuggestionSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addStatsViewer', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addStatsViewer'), _class2.prototype)), _class2)) || _class);
exports.default = AddStatsViewerField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/AddStatsViewerField/AddStatsViewerField.js
// module id = 2188
// module chunks = 1